import React from 'react';
import { Link } from 'react-router';
import OwlCarousel from 'react-owl-carousel2';
import { connect } from 'react-redux';
import {getSurface} from '../actions/surfaceActions';
import {getCategory} from '../actions/categoryActions';
import {getOption} from '../actions/optionActions';
import {filterMatches, getProduct} from '../actions/productActions';
import {addChoice, productHasBeenChosen} from '../actions/choiceActions';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import {APP_TITLE} from '../constants/config';
import { Helmet } from 'react-helmet';

class ProductList extends React.Component{
    constructor(props) {
        super(props);
    }

    getNextStep(product) {

        if(!product || !product.category || !this.props.categories) return false;
        const current_index = this.props.categories.indexOf(this.props.category);

        const next_step = this.props.categories[current_index+1];
        if(!next_step) return false;

        return next_step;

    }

    getNextStepUrl(product) {

        const next_category = this.getNextStep(product);
        if(next_category.slug == "aftercare") return "/" + this.props.surface.slug + "/" + next_category.slug + "/" + this.props.option + "-aftercare/products";
        return "/" + this.props.surface.slug + "/" + next_category.slug;

    }

    pager(index) {
        if(this.props.products.length > 1) {
            return (
                <div className="px-lg-3 mt-5">
                    <div className="pager bg-primary text-white py-2 px-3">
                        {(index > 0) ? <i className="fa fa-chevron-circle-left mr-3" onClick={() => this.refs.product_carousel.prev()}/> : ""}
                        Alternative products available
                        <span className="float-md-right">
                            {index+1} / {this.props.products.length}
                            {(index+1 < this.props.products.length) ? <i className="fa fa-chevron-circle-right ml-3" onClick={() => this.refs.product_carousel.next()}/> : ""}
                        </span>
                    </div>
                </div>
            );
        }
        return;
    }

    surfaceHeading() {
        if(!this.props.surface) return;
        return (
            <div>
                <h3 className="mt-0 pr-5"><span className="text-primary">Your surface</span><br />{this.props.surface.name}</h3>
                <hr />
            </div>
        );
    }

    pageTitle() {
        if(this.props.surface) {
            return `Your selections for ${this.props.surface.name}`;
        } else if(this.props.products.length == 1) {
            return `${this.props.products[0].title}`;
        }
        return "Your selection";
    }

    datasheetLink(product) {
        if(!product.datasheet) return;
        return (
            <h4 className="mt-4">
                <a href={product.datasheet}><i className="fa fa-chevron-circle-down mr-2" /> Download technical data sheet</a>
            </h4>
        );
    }

    choicesBtn(b) {
        if(productHasBeenChosen(b.id, this.props.choices)) {
            return (
                <Link to={"/choices/" + this.props.surface.slug} className="btn btn-success btn-lg mx-2 d-flex align-items-center"><span>View your choices</span></Link>
            );
        } else {
            return (
                <button className="btn btn-primary btn-lg mx-2" onClick={() => this.props.addChoice(b.id, b.title)}>Add to my choices</button>
            );
        }
    }

    render() {
        const options = {
            items: 1,
            nav: false,
            autoplay: false,
            loop: false,
        };

        if(this.props.products) {
            return (
                <div id="products">
                    <Helmet>
                        <title>{this.pageTitle()} | {APP_TITLE}</title>
                    </Helmet>
                    <OwlCarousel ref="product_carousel" options={options}>
                        {this.props.products.map((b, i) =>
                            <div key={i} className="slide">
                                <div className="container-fluid">
                                    <div className="row">
                                        <div className="col-12 col-md-6 mb-5 pt-5">
                                            <img src={b.image} alt={b.title} title={b.title} className="img-fluid d-block mx-auto"/>
                                            <div className="d-flex px-lg-4 justify-content-center buttons">
                                                {this.choicesBtn(b)}

                                                {(this.getNextStep(b)) ? <Link to={this.getNextStepUrl(b)} className="btn btn-primary btn-lg mx-2">Choose {this.getNextStep(b).name == "tooling-up" ? this.getNextStep(b).slug : this.getNextStep(b).name} for this</Link> : ""}
                                            </div>
                                            {this.pager(i)}
                                        </div>
                                        <div className="col-12 col-md-6 entry">
                                            <div className="bg-white pl-4 pl-sm-5 pb-5">
                                                {this.surfaceHeading()}
                                                <div className="entry-content pr-4 pr-sm-5">
                                                    <h1 className="mt-0"><span className="text-primary">Use</span><br />{b.title}</h1>
                                                    <div className="entry-content mt-3" dangerouslySetInnerHTML={{__html: b.content}} />
                                                    <p className="small mt-3">Please note that this information is offered as general guidance only and without guarantee. Your specific circumstances may need an alternative approach. In case of doubt, any process should be tried out in an inconspicuous area before general application.</p>
                                                    {this.datasheetLink(b)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </OwlCarousel>
                </div>
            );
        } else {
            return (
                <div className="container2">
                    <h2 className="text-center">No matches available</h2>
                </div>
            );
        }
    }

}

// Maps state from store to props
const mapStateToProps = (state, props) => {

    if(props.params.productSlug) {

        let products = getProduct(props.params.productSlug, state);
        return {
            products: products,
        };
    }


    let category = getCategory(props.params.category, state);
    let products = filterMatches(props.params, state);
    return {
        // You can now say this.props.books
        surface: getSurface(props.params.floorSurface, state),
        categories: state.categories,
        category: category,
        option: getOption(props.params.option, state),
        products: products,
        choices: state.choices,
    };

};

// Maps state from store to props
const mapDispatchToProps = (dispatch) => {
    return {
        addChoice: (id, name) => {
            toast.success("\"" + name + "\" added to your choices.");
            dispatch(addChoice(id));
        }
    };
};

ProductList.propTypes = {
    surface: PropTypes.object,
    category: PropTypes.object,
    option: PropTypes.string,
    categories: PropTypes.array,
    options: PropTypes.array,
    products: PropTypes.array,
    choices: PropTypes.array,
    addChoice: PropTypes.func,
};

// Use connect to put them together
export default connect(mapStateToProps, mapDispatchToProps)(ProductList);


// WEBPACK FOOTER //
// ./src/components/ProductList.js